export default function Menu() {
    return (
        <div className='Menu'>
            Want or need Medicare insurance? 
            <a href="https://www.sunfirematrix.com/app/blazesync/medicareadvocates/8644830/2025 "> <i>Click here!</i></a>
            </div>
    );
}